import { FormContextType, RJSFSchema, StrictRJSFSchema, WidgetProps, getTemplate } from '@rjsf/utils';

// Overrides the default RJSF TextareaWidget to use `minRows` instead of the deprecated `rows` prop on MUI TextField.
export function TextareaWidget<T = any, S extends StrictRJSFSchema = RJSFSchema, F extends FormContextType = any>(
  props: WidgetProps<T, S, F>
) {
  const { options, registry } = props;
  const BaseInputTemplate = getTemplate<'BaseInputTemplate', T, S, F>('BaseInputTemplate', registry, options);

  let minRows: string | number = 5;
  if (typeof options.rows === 'string' || typeof options.rows === 'number') {
    minRows = options.rows;
  }

  return <BaseInputTemplate {...props} multiline minRows={minRows} />;
}
